interface ConfirmDialogProps {
  isOpen: boolean
  onClose: () => void
  onConfirm: () => void
  title: string
  message: string
  confirmLabel?: string
  confirmVariant?: 'primary' | 'danger'
  loading?: boolean
}

export function ConfirmDialog({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmLabel = 'Confirm',
  confirmVariant = 'primary',
  loading = false
}: ConfirmDialogProps) {
  if (!isOpen) return null

  const confirmButtonClass = confirmVariant === 'danger' 
    ? 'bg-red-600 text-white hover:bg-red-700 disabled:opacity-50'
    : 'bg-primary-600 text-white hover:bg-primary-700 disabled:opacity-50'

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full mx-4">
        <div className="p-6">
          <h3 className="text-lg font-medium text-gray-900 mb-4">
            {title}
          </h3>
          <p className="text-gray-600 mb-6">
            {message}
          </p>
          <div className="flex justify-end space-x-3">
            <button
              onClick={onClose}
              disabled={loading}
              className="px-4 py-2 text-gray-700 bg-gray-100 rounded-full hover:bg-gray-200 disabled:opacity-50 transition-colors"
            >
              Cancel
            </button>
            <button
              onClick={onConfirm}
              disabled={loading}
              className={`px-4 py-2 rounded-full transition-colors ${confirmButtonClass}`}
            >
              {loading && (
                <div className="inline-block mr-2 h-4 w-4 animate-spin rounded-full border-2 border-t-transparent border-current" />
              )}
              {confirmLabel}
            </button>
          </div>
        </div>
      </div>
    </div>
  )
} 